import {
  HTTP_INTERCEPTORS,
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastrNotificationService } from '../services/ui/toastr-notification.service';
import {
  RESPONSE_CODES,
  SKIP_AUTH_HEADER,
  SKIP_ERROR_NOTIFICATION_HEADER,
} from '../helpers/global/global.constant';
import { HttpStatusError } from '../interfaces/api/http-status-error.interface';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { UserActions } from '../states/auth/auth.actions';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private _notificationService: ToastrNotificationService,
    private _translateService: TranslateService,
    private _store: Store
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        const isSessionRequest = !req.headers.has(SKIP_AUTH_HEADER);
        if (error.status === RESPONSE_CODES.UNAUTHORIZED && isSessionRequest) {
          this._store.dispatch(UserActions.userLogout());
        }
        if (!req.headers.has(SKIP_ERROR_NOTIFICATION_HEADER)) {
          let errorMessage = this._translateService.instant('words.unknownError');

          if (error.error && error.error.message) {
            errorMessage = error.error.message;
          }

          this._notificationService.showNotification({
            type: 'error',
            title: 'Error',
            message: errorMessage,
          });
        }

        const rawMessage = error.error?.message ?? '';
        const errorMessageTranslated =
          this._notificationService.getMessageTest(rawMessage);

        const statusError: HttpStatusError = Object.assign(
          new Error(errorMessageTranslated),
          { status: error.status }
        );

        return throwError(() => statusError);
      })
    );
  }
}
export const ERROR_INTERCEPTOR_PROVIDERS = [
  { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
];
